// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2Q88z","list":"BalanceDue_list__1oCfF","listRow":"BalanceDue_listRow__1ugBx","total":"BalanceDue_total__2_Bqi"};